import { ImportStatus } from '@keepeek/commons';
import { selectorFamily } from 'recoil';
import { kpkMediaImportsAtom, kpkMediaImportsProgressAtom } from './atoms.js';

var UploadStatus;
(function (UploadStatus) {
    UploadStatus["NO_FILES"] = "NoFiles";
    UploadStatus["UPLOADING"] = "Uploading";
    UploadStatus["ERROR"] = "Error";
    UploadStatus["SUCCESS"] = "Success";
    UploadStatus["SUCCESS_WITH_ERRORS"] = "SuccessWithErrors";
})(UploadStatus || (UploadStatus = {}));
/**
 * Media import without progress.
 */
var kpkMediaImportsSelector = selectorFamily({
    key: "KpkMediaImportsSelector",
    get: function (key) {
        return function (_a) {
            var get = _a.get;
            return get(kpkMediaImportsAtom(key));
        };
    }
});
/**
 * Get a media import by uuid with progress information.
 * This selector must have reference equality to avoid useless renders.
 */
var kpkMediaImportsProgressSelector = selectorFamily({
    key: "KpkMediaImportsProgressSelector",
    get: function (_a) {
        var key = _a.key, uuid = _a.uuid;
        return function (_a) {
            var get = _a.get;
            return get(kpkMediaImportsProgressAtom(key)).find(function (e) { return e.uuid === uuid; });
        };
    }
});
/**
 * Global import status
 */
var importStatusSelector = selectorFamily({
    key: "ImportStatusSelector",
    get: function (key) {
        return function (_a) {
            var get = _a.get;
            // This will update at queue upload end to avoid useless renders
            var kpkMediaImports = get(kpkMediaImportsSelector(key));
            if (kpkMediaImports.length === 0) {
                return UploadStatus.NO_FILES;
            }
            var uploading = kpkMediaImports.find(function (file) { return file.status === ImportStatus.ADDED || file.status === ImportStatus.UPLOADING; });
            if (uploading) {
                return UploadStatus.UPLOADING;
            }
            var error = kpkMediaImports.filter(function (file) { return file.status === ImportStatus.ERROR; });
            if (error.length === kpkMediaImports.length) {
                return UploadStatus.ERROR;
            }
            var success = kpkMediaImports.filter(function (file) { return file.status === ImportStatus.SUCCESS; });
            if (success.length === kpkMediaImports.length) {
                return UploadStatus.SUCCESS;
            }
            var successWithErrors = kpkMediaImports.filter(function (file) { return file.status === ImportStatus.ERROR || file.status === ImportStatus.SUCCESS; });
            if (successWithErrors.length === kpkMediaImports.length) {
                return UploadStatus.SUCCESS_WITH_ERRORS;
            }
            return UploadStatus.ERROR;
        };
    }
});

export { UploadStatus, importStatusSelector, kpkMediaImportsProgressSelector, kpkMediaImportsSelector };
//# sourceMappingURL=selectors.js.map
